import { FormattedMessage } from '@subaio/components'
import { cases } from '@subaio/utils'

import { Card } from 'components/Card'
import { HeaderIconInfo } from 'components/Icons'
import { ContentCenter, HeaderIconWrapper, SecondaryText, Title } from 'components/Layout'

type Props = {
	type: 'noOffer' | 'noExisting'
}

export const ErrorInsurance = ({ type }: Props) => (
	<Card>
		<ContentCenter>
			<HeaderIconWrapper>
				<HeaderIconInfo />
			</HeaderIconWrapper>
			<Title>
				{cases(type, {
					noOffer: () => (
						<FormattedMessage id='error.insurance.titleNoOffer' defaultMessage='Sorry, no results found' />
					),
					noExisting: () => (
						<FormattedMessage
							id='error.insurance.titleNoExisting'
							defaultMessage='Unfortunately, we cannot compare your insurance'
						/>
					),
				})}
			</Title>
			<SecondaryText>
				{cases(type, {
					noOffer: () => (
						<FormattedMessage
							id='error.insurance.textNoOffer'
							defaultMessage='Based on the data you entered, we unfortunately cannot make a comparison.'
						/>
					),
					noExisting: () => (
						<FormattedMessage
							id='error.insurance.textNoExisting'
							defaultMessage='Based on the information you entered, we could not find any results for your current insurance.'
						/>
					),
				})}
			</SecondaryText>
		</ContentCenter>
	</Card>
)
